module.exports = __webpack_public_path__ + "img/mount-logo-black-notext.d94aaf9d.png";